import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import userReducer from './slices/userSlice'
import dashboardReducer from './slices/dashboardSlice'
import associatesReducer from './slices/associateApiSlice'
import designationsReducer from './slices/designationsApiSlice'
import orgTreeReducer from './slices/orgTreeApiSlice'

const store = configureStore({
  reducer: {
    designations: designationsReducer,
    associates: associatesReducer,
    auth: authReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    orgTree: orgTreeReducer,
  },
})

export default store
